import { CompareProducts, useCompare } from '@iheartjane/menu';
import type { ProductCardSize } from '@iheartjane/types';

interface MenuCompareToggleProps {
  cardSize: ProductCardSize;
  onToggle: () => void;
  placement: 'overlay' | 'inline';
  productId: number;
  productName: string;
}

/**
 * Provider-connected leaf for product card's Compare pill. It is the only
 * per-card subscriber to compare state, so (de)selecting a product re-renders
 * just these small toggles and the compare bar — not the whole product grid.
 */
export const MenuCompareToggle = ({
  cardSize,
  onToggle,
  placement,
  productId,
  productName,
}: MenuCompareToggleProps) => {
  const { isSelected } = useCompare();

  return (
    <CompareProducts.Toggle
      variant="labeled"
      cardSize={cardSize}
      placement={placement}
      isSelected={isSelected(productId)}
      onToggle={onToggle}
      productName={productName}
    />
  );
};
